<div class="bgf-page shopify">
    <div class="bgf-page__header">
        <h1 class="bgf-page__title">
            <i class="fa-brands fa-shopify"></i>
            <span>Shopify</span>
        </h1>
    </div>
    <form class="bgf-form bgf-form--box shopify-form">
        <label class="form-label">Beállítások</label>
        <div class="field">
            <label class="label">Bekapcsolva</label>
            <mat-slide-toggle
                color="primary"
                [(ngModel)]="isShopEnabled"
                (click)="shopToggleChanged($event)"
                name="isShopEnabled"
                [aria-label]="isShopEnabled ? 'Bekapcsolva' : 'Nincs bekapcsolva'"
            >
            </mat-slide-toggle>
        </div>
        <div class="field mb-2">
            <label for="Shop name" class="label">Shop név:</label>
            <div class="control">
                <input
                    type="text"
                    class="input"
                    name="shopName"
                    [(ngModel)]="shopName"
                    placeholder="boardgeekfox vagy valami.myshopify.com"
                >
            </div>
        </div>
        <div class="field mb-2">
            <label for="Client ID" class="label">Client ID:</label>
            <div class="control is-flex is-align-items-center">
                <input type="text" class="input" name="appId" [(ngModel)]="appId">
                <i class="fa-solid fa-check has-text-success" *ngIf="appId"></i>
            </div>
        </div>
    </form>

    <button class="button is-primary" [ngClass]="{'is-loading': creatingAuthUrl}" [disabled]="creatingAuthUrl" (click)="openShopAuth()">
        Összekötés Shopify-jal
    </button>
    <br>
    <button class="button is-primary mt-2" [disabled]="!isShopEnabled" (click)="updateOrders()">
        Megrendelések frissítése
    </button>
 

</div>
